import {
  MaterialRequisitionDocumentResponse,
  MaterialRequisitionItemFormResponse,
} from '@Types/api/form';
import { RequestListSearchResponse } from '@Types/api/requestList';

export const getCounterValue = (
  isSelected: boolean,
  selectedItems: (string | number | MaterialRequisitionDocumentResponse)[],
  listItems:
    | RequestListSearchResponse<MaterialRequisitionItemFormResponse>
    | MaterialRequisitionDocumentResponse[]
    | undefined
): number => {
  const isDocumentItemsList = Array.isArray(listItems);

  if (isDocumentItemsList && isSelected) {
    return selectedItems.length;
  }

  if (isDocumentItemsList && !isSelected) {
    return listItems?.length;
  }

  if (!isDocumentItemsList && listItems?.content && isSelected) {
    return selectedItems.length;
  }

  if (!isDocumentItemsList && listItems?.content && !isSelected) {
    return listItems?.content.length;
  }

  return 0;
};
